/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ScheduleWhoFragmentDoc } from './Fragments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseScheduleWhoDataQueryVariables = Types.Exact<{
  memberIds: Array<Types.Scalars['ID']['input']>;
  limit: Types.Scalars['Int']['input'];
}>;


export type UseScheduleWhoDataQuery = { organisationMemberships: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };


export const UseScheduleWhoDataDocument = gql`
    query UseScheduleWhoData($memberIds: [ID!]!, $limit: Int!) {
  organisationMemberships(
    offset: 0
    limit: $limit
    sorting: [{column: firstname, direction: asc}]
    filters: {ids: $memberIds}
  ) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          ...ScheduleWho
        }
      }
    }
  }
}
    ${ScheduleWhoFragmentDoc}`;

/**
 * __useUseScheduleWhoDataQuery__
 *
 * To run a query within a React component, call `useUseScheduleWhoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseScheduleWhoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseScheduleWhoDataQuery({
 *   variables: {
 *      memberIds: // value for 'memberIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUseScheduleWhoDataQuery(baseOptions: Apollo.QueryHookOptions<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables> & ({ variables: UseScheduleWhoDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>(UseScheduleWhoDataDocument, options);
      }
export function useUseScheduleWhoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>(UseScheduleWhoDataDocument, options);
        }
export function useUseScheduleWhoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>(UseScheduleWhoDataDocument, options);
        }
export type UseScheduleWhoDataQueryHookResult = ReturnType<typeof useUseScheduleWhoDataQuery>;
export type UseScheduleWhoDataLazyQueryHookResult = ReturnType<typeof useUseScheduleWhoDataLazyQuery>;
export type UseScheduleWhoDataSuspenseQueryHookResult = ReturnType<typeof useUseScheduleWhoDataSuspenseQuery>;
export type UseScheduleWhoDataQueryResult = Apollo.QueryResult<UseScheduleWhoDataQuery, UseScheduleWhoDataQueryVariables>;